import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["exact", "strict"];
import PropTypes from 'prop-types';
import UITab from 'UIComponents/nav/UITab';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIRouterTab(props) {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, rest, {
    component: UITab
  }));
}
const _AbstractRouterLink$p = AbstractRouterLink.propTypes,
  sanitizedAbstractRouterLinkPropTypes = _objectWithoutPropertiesLoose(_AbstractRouterLink$p, ["component"]);
const _clonePropTypes = clonePropTypes(UITab),
  sanitizedTabPropTypes = _objectWithoutPropertiesLoose(_clonePropTypes, ["tabId"]);
UIRouterTab.propTypes = Object.assign({}, sanitizedAbstractRouterLinkPropTypes, sanitizedTabPropTypes, {
  children: PropTypes.node,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  // TODO remove after UIComponents is no longer createReactClass
  tooltipProps: PropTypes.object,
  onClick: PropTypes.func,
  // TODO override to get around UITabs childrenPropTypeValidator
  tabId: PropTypes.string
});
UIRouterTab.defaultProps = Object.assign({}, cloneDefaultProps(UITab), {
  exact: false,
  strict: false
});